module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-checkbox-group', {
    model: {
      value: (_vm.checkedCategoryList),
      callback: function($$v) {
        _vm.checkedCategoryList = $$v
      },
      expression: "checkedCategoryList"
    }
  }, [_c('div', {
    staticClass: "category-order"
  }, _vm._l((_vm.orderDisplay), function(group, groupIndex) {
    return _c('div', {
      key: group.id,
      staticClass: "categoryGroup-div"
    }, [_vm._v("\n        " + _vm._s(groupIndex + 1) + ". " + _vm._s(group.name) + "\n        "), _c('div', {
      staticClass: "categoryList-div"
    }, _vm._l((_vm.orderDisplay[groupIndex].category), function(item, categoryIndex) {
      return _c('div', {
        key: item.id,
        staticClass: "category-div",
        class: _vm.getStatusStyle(groupIndex, categoryIndex)
      }, [_c('el-checkbox', {
        attrs: {
          "label": item.id
        },
        on: {
          "change": function($event) {
            return _vm.clickCheckbox(groupIndex, categoryIndex, $event.target.checked)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), (_vm.showUpBtn(groupIndex, categoryIndex)) ? _c('el-button', {
        staticClass: "el-icon-caret-top category-btn",
        attrs: {
          "size": "mini"
        },
        on: {
          "click": function($event) {
            return _vm.orderUp(groupIndex, categoryIndex)
          }
        }
      }) : _vm._e(), _vm._v(" "), (_vm.showDownBtn(groupIndex, categoryIndex)) ? _c('el-button', {
        staticClass: "el-icon-caret-bottom category-btn",
        attrs: {
          "size": "mini"
        },
        on: {
          "click": function($event) {
            return _vm.orderDown(groupIndex, categoryIndex)
          }
        }
      }) : _vm._e()], 1)
    }), 0)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-314377df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/CategoryOrder.vue
// module id = 915
// module chunks = 170